// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2vPRH","error":"Textarea_error__3KyOt","readonly":"Textarea_readonly__39RY8","disabled":"Textarea_disabled___l394"};